import { GHubThemeType } from '../../../modules/theme';
import {
  alexForbesBarChartColors,
  glacierBarChartColors
} from '../../../utils/chart-colors/chart-colors';

const defaultColors = {
  primary: '#2f53f5ff',
  secondary: '#f8b4b4ff',
  error: '#f71111ff'
};

export const getDatasetDifferences = (foreground: number[], background: number[]): number[] => {
  return foreground.map((fg, idx) => {
    const bg = background[idx] ?? 0;
    if (bg === 0) return 0;
    const diff = fg - bg;
    return diff > 0 ? diff : 0;
  });
};

export const subtractArrays = (arrayA: number[], arrayB: number[]): number[] => {
  return arrayA.map((a, idx) => a - (arrayB[idx] ?? 0));
};

export const getColors = (theme: GHubThemeType) => {
  switch (theme) {
    case 'af':
      return alexForbesBarChartColors;
    case 'glacier':
      return glacierBarChartColors;
    default:
      return defaultColors;
  }
};
